import React, { Component } from "react";
import { Input, Button, Table, Grid, Segment, Divider, Card
} from 'semantic-ui-react'
import axios from "axios";

var url = "https://encontech.azurewebsites.net/api/admins";
//var url = "http://localhost:5000/api/admins";



interface Admin {
  id: number;
  email: string;
}
class RoleManagement extends Component {
  state = {
    adminData:new Array<Admin>(),
    adminEmail: ""
  };

  handleChange(e:any) {
    console.log(e.target.value);
    this.setState({adminEmail: e.target.value});
  }

  removeAdmin = (e: any) => {
    axios
    .delete(url+ "/" + e)
    .then(res => {
      this.setState({
        adminData: this.state.adminData.filter( (x:Admin) => { return x.id != e})
      });
    })
    .catch(err => {
      console.log(err);
    });
  }

  addAdmin(e:any) {
    console.log("adminEmail: " + this.state.adminEmail);
    axios
    .post(url,{ email: this.state.adminEmail} )
    .then(res => {
      var tempAdminData = this.state.adminData;
      tempAdminData.push(res.data);
      this.setState({
       adminData: tempAdminData,
       adminEmail: ""
      });
      console.log(this.state.adminData);
      console.log("adminEmail: " + this.state.adminEmail);

    })
    .catch(err => {
      console.log(err);
    });
  }

  componentDidMount() {
 
    axios.get(url).then((response) => {
      this.setState({
        adminData: response.data,
      });
    });
  }



  render() {
  return(
<div style={{ height:"500px" }}>
        <h1>Admin (Role Management)</h1>
      <Segment placeholder>
        
        <Grid columns={2} relaxed='very' stackable>

        <Grid.Column >
        
        <Card style={{ width:"350px" }}>
          <Card.Content header='Grant Role'/>
          <Card.Content description='Adding a user to this role will give them the ability to add and modify job sites.  This will also give the user the ability to manage the administration role.' />
          <Card.Content>
          <Grid columns={2} relaxed='very' >
            <Grid.Column><Input icon='user' iconPosition='left' value={this.state.adminEmail} onChange={this.handleChange.bind(this)} /></Grid.Column>
            <Grid.Column><Button content="Add User" positive onClick={this.addAdmin.bind(this)} /></Grid.Column>
            </Grid>
          </Card.Content>
          <Card.Content>
          
          </Card.Content>
        </Card>
    
         
         
         </Grid.Column>
      
      <Grid.Column>  
        <Table celled style={{ width:"350px" }}>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Role Members</Table.HeaderCell>
        <Table.HeaderCell></Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {
    this.state.adminData.map((admin: any) => (
     
        <Table.Row key={admin.id}>
        <Table.Cell>{admin.email} </Table.Cell>
        <Table.Cell><Button size='mini' negative onClick={() => this.removeAdmin(admin.id)} >Delete</Button></Table.Cell>
        </Table.Row>
    ))}
    </Table.Body>
    </Table>
      </Grid.Column>

      
    </Grid>

    <Divider vertical></Divider>
        
      </Segment>
      </div>
)
}
}

export default RoleManagement